import { ContextService } from './context.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private context = inject(ContextService);
  private cookieService = inject(CookieService);

  intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (httpRequest.url.indexOf('/basic-auth') > -1) {
      httpRequest = httpRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${this.cookieService.get('auth-token')}`,
        },
      });
    } else if (
      httpRequest.url.indexOf('/token') === -1 &&
      httpRequest.url.indexOf('/register') === -1 &&
      httpRequest.url.indexOf('/registration/') === -1
    ) {
      httpRequest = httpRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${this.context.token}`,
        },
      });
    }

    return next.handle(httpRequest);
  }
}
